import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getOrgsDocs = async (serviceCompanyId) => {
  return await request.get(
    `/Docs/orgs`,
    { serviceCompanyId },
    'При получении организаций произошла ошибка'
  );
};

const useOrgsDocsQuery = (serviceCompanyId, options) =>
  useQuery(
    queryKeys.orgsDocs(serviceCompanyId),
    () => getOrgsDocs(serviceCompanyId),
    {
      staleTime: Infinity,
      ...options,
    }
  );

export default useOrgsDocsQuery;
